//export const url = { main: 'https://requesthq-backend-dev-tdrgvnyuhq-de.a.run.app'};
//export prod const url = { main: 'https://requesthq-backend-anz73xoirq-uc.a.run.app'};
//export const url = { main: 'https://requesthq-backend-dev-tdrgvnyuhq-uc.a.run.app'};
//export const url = { main: 'https://requesthq-backend-dev-tdrgvnyuhq-de.a.run.app'}; //dev
export const url = {
  main: 'https://morawa-requesthq-uat-backend-v5powylsia-uc.a.run.app',
}; //uat
export const map_navigation = { lat: -29.0341994, lng: 115.7267837 };
